/**
 * Buy 5 Get 1 Free A/B test — page copy for the b5g1 group.
 *
 * Swaps text that lives outside the cart counter so the test needs no Liquid edits for it:
 *   - header menu (desktop mega menu + mobile drawer): promo link label and URL
 *   - /collections/10-off-5: breadcrumb, banner title/description and the SEO description block
 *   - /pages/stash-up (stash-pass-tier-cards): "Continue without a membership" copy and "Shop now" URL
 *
 * The group comes from window.LPPromoGroup (snippets/theme-settings.liquid). Copy is applied
 * while the group is "b5g1" and the original markup is restored if the group changes (e.g. when
 * Intelligems assigns a different group after load). To roll back, remove this file and its
 * <script> tag in layout/theme.liquid.
 */
(function () {
  const COPY = {
    menuFrom: '10% off 5',
    menuTo: 'Buy 5, Get 1 Free',
    collectionUrl: '/collections/buy-5-get-1-free',
    collectionHandle: '10-off-5',
    collectionTitle: 'Buy 5, Get 1 Free',
    collectionDescription: 'Add any 6 items. Your lowest priced card is free.',
    stashTitle: 'Buy 5, Get 1 Free',
    stashDescription: 'Add any 6 items. Your lowest priced card is free.',
    stashPerk: 'Buy 5, Get 1 Free',
  };

  // Originals (element innerHTML, text node values) and elements this script created, so the
  // swap is reversible.
  const originals = new Map();
  const textOriginals = new Map();
  const attrOriginals = [];
  const created = [];

  function setAttr(element, name, value) {
    if (!element || !element.hasAttribute(name)) return;
    attrOriginals.push([element, name, element.getAttribute(name)]);
    element.setAttribute(name, value);
  }

  function setHTML(element, html) {
    if (!element) return;
    if (!originals.has(element)) originals.set(element, element.innerHTML);
    element.innerHTML = html;
  }

  function setText(element, text) {
    const span = document.createElement('span');
    span.textContent = text;
    setHTML(element, span.innerHTML);
  }

  function create(tag, className, text, insertAfter) {
    if (!insertAfter) return;
    const element = document.createElement(tag);
    element.className = className;
    element.textContent = text;
    insertAfter.insertAdjacentElement('afterend', element);
    created.push(element);
  }

  function swapMenu() {
    document.querySelectorAll('a[data-title], summary[data-title]').forEach((link) => {
      if (link.getAttribute('data-title') !== COPY.menuFrom) return;
      setAttr(link, 'href', COPY.collectionUrl);
      setAttr(link, 'data-href', COPY.collectionUrl);
      const walker = document.createTreeWalker(link, NodeFilter.SHOW_TEXT);
      const textNodes = [];
      while (walker.nextNode()) textNodes.push(walker.currentNode);
      // Only the text node changes, so icons inside the link (drawer arrows) are kept.
      textNodes.forEach((node) => {
        if (node.nodeValue.trim() !== COPY.menuFrom) return;
        if (!textOriginals.has(node)) textOriginals.set(node, node.nodeValue);
        node.nodeValue = node.nodeValue.replace(COPY.menuFrom, COPY.menuTo);
      });
    });
  }

  function isB5G1Collection() {
    return new RegExp(`^/collections/${COPY.collectionHandle}(/|$)`).test(window.location.pathname);
  }

  function swapCollection() {
    if (!isB5G1Collection()) return;

    document.querySelectorAll('.collection-hero__title, .lp-collection-banner__title').forEach((title) => {
      setText(title, COPY.collectionTitle);
    });

    // Breadcrumb: the last item is the current collection (snippets/breadcrumb-rescursive.liquid).
    document.querySelectorAll('.breadcrumbs__list').forEach((list) => {
      const labels = list.querySelectorAll('.breadcrumbs__item .breadcrumbs__label');
      if (labels.length > 1) setText(labels[labels.length - 1], COPY.collectionTitle);
    });

    // Hero banner: replace existing descriptions, or add one under the title.
    document.querySelectorAll('.collection-hero__text-wrapper').forEach((wrapper) => {
      const descriptions = wrapper.querySelectorAll('.collection-hero__description');
      if (descriptions.length) {
        descriptions.forEach((description) => setHTML(description, `<p>${COPY.collectionDescription}</p>`));
      } else {
        create('div', 'collection-hero__description', COPY.collectionDescription, wrapper.querySelector('.collection-hero__title'));
      }
    });

    // "New Bean" banner.
    document.querySelectorAll('.lp-collection-banner__content').forEach((content) => {
      const subtitle = content.querySelector('.lp-collection-banner__subtitle');
      if (subtitle) {
        setText(subtitle, COPY.collectionDescription);
      } else {
        create('h2', 'lp-collection-banner__subtitle', COPY.collectionDescription, content.querySelector('.lp-collection-banner__title'));
      }
    });

    // SEO description block (collection-description / main-collection-product-grid sections).
    document.querySelectorAll('.collection-descriptive_text').forEach((block) => {
      const heading = document.createElement('h2');
      heading.textContent = COPY.collectionTitle;
      const paragraph = document.createElement('p');
      paragraph.textContent = COPY.collectionDescription;
      setHTML(block, heading.outerHTML + paragraph.outerHTML);
    });
  }

  function swapStashPage() {
    document.querySelectorAll('.stash-pass-tier-cards__no-membership-content').forEach((content) => {
      const title = content.querySelector('.stash-pass-tier-cards__no-membership-title');
      setText(title, COPY.stashTitle);

      const description = content.querySelector('.stash-pass-tier-cards__no-membership-desc');
      if (description) {
        setText(description, COPY.stashDescription);
      } else {
        create('p', 'stash-pass-tier-cards__no-membership-desc', COPY.stashDescription, title);
      }

      setAttr(content.querySelector('.stash-pass-tier-cards__no-membership-link'), 'href', COPY.collectionUrl);

      content.querySelectorAll('.stash-pass-tier-cards__no-membership-perk-text').forEach((perk) => {
        if (/10%\s*off\s*5/i.test(perk.textContent)) setText(perk, COPY.stashPerk);
      });
    });
  }

  function restore() {
    originals.forEach((html, element) => {
      element.innerHTML = html;
    });
    originals.clear();
    textOriginals.forEach((value, node) => {
      node.nodeValue = value;
    });
    textOriginals.clear();
    attrOriginals.splice(0).reverse().forEach(([element, name, value]) => element.setAttribute(name, value));
    created.splice(0).forEach((element) => element.remove());
  }

  function update() {
    const isB5G1 = Boolean(window.LPPromoGroup && window.LPPromoGroup.isB5G1());
    if (!isB5G1) {
      restore();
      return;
    }
    if (originals.size || textOriginals.size || attrOriginals.length || created.length) return;
    swapMenu();
    swapCollection();
    swapStashPage();
  }

  document.addEventListener('promo-group:change', update);

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', update);
  } else {
    update();
  }
})();
